// import { useSignIn } from 'src/services/login';
import { Helmet } from 'react-helmet-async'
// @mui
import styled from '@emotion/styled'
import { Box, Button, CircularProgress, Container, Typography } from '@mui/material'
// hooks
import useResponsive from '../hooks/useResponsive'
// components
import Logo from '../components/logo'
// sections
// import { LoginForm } from '../sections/auth/login'
// import { useSignIn } from 'src/services/auth'
import { useState } from 'react'
// import { toast } from 'react-toastify'
// import { useAuth } from 'src/hooks/useAuth'
import { useNavigate } from 'react-router-dom'
import { useMsal } from '@azure/msal-react'
import { useAuthStore } from 'src/store/auth'
import { routes } from 'src/routes/index.routes'
import { loginRequest } from 'src/config/msalConfig'

// ----------------------------------------------------------------------

// const StyledRoot = styled('div')(({ theme }) => ({
//   [theme.breakpoints.up('md')]: {
//     display: 'flex',
//   },
// }))

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}))

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
  gap: theme.spacing(3),
}))

const SecurityNote = styled('div')(({ theme }) => ({
  textAlign: 'center',
  p: {
    color: '#64748b',
    fontSize: '0.85rem',
    margin: 0,
    padding: '0.5rem',
    borderRadius: '6px',
    background: 'rgba(100, 116, 139, 0.1)',
  },
}))

// ----------------------------------------------------------------------

export default function LoginPage() {
  const mdUp = useResponsive('up', 'md')
  const handleUser = useAuthStore((state) => state.handleUser)
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const { instance } = useMsal()

  // const handleUser = useUserStore((state) => state.handleUser)
  const handleLogin = async () => {
    setIsLoading(true)
    console.log('Login initiated')
    try {
      const response = await instance.loginPopup(loginRequest)
      console.log('Attempting to login with Microsoft...')

      if (response.account && response.accessToken) {
        instance.setActiveAccount(response.account)
        handleUser({
          username: response.account.username,
          email: response.account.email,
        })
        navigate(routes.users, { replace: true })
      } else {
        console.error('Login failed (no account or accessToken found).')
        handleUser(null)
      }
    } catch (error) {
      console.error('Login failed (no account or accessToken found).')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <Helmet>
        <title> Login | FDC Dash Admin </title>
      </Helmet>

      <Logo
        sx={{
          position: 'fixed',
          top: { xs: 16, sm: 24, md: 40 },
          left: { xs: 16, sm: 24, md: 40 },
        }}
      />

      {mdUp && (
        <StyledSection>
          <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
            Hi, Welcome Back
          </Typography>
          <img src="/assets/illustrations/illustration_login.png" alt="login" />
        </StyledSection>
      )}

      <Container maxWidth="sm">
        <StyledContent>
          <Button
            startIcon={
              <Box
                component="img"
                sx={{ width: 20, height: 20 }}
                src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjUgMjFDMTYuMzAxIDIxIDIxIDE2LjMwMSAyMSAxMC41UzE2LjMwMSAwIDEwLjUgMFMwIDQuNjk5IDAgMTAuNVM0LjY5OSAyMSAxMC41IDIxWiIgZmlsbD0iIzAwNzJDNiIvPgo8cGF0aCBkPSJNMTAuNSAxNC4zNzVIMTQuNzVWMTAuMTI1SDEwLjVWMTQuMzc1WiIgZmlsbD0iIzI4QTRGRiIvPgo8cGF0aCBkPSJNNi4yNSAxNC4zNzVIMTAuNVYxMC4xMjVINi4yNVYxNC4zNzVaIiBmaWxsPSIjMDBBNkZCIi8+CjxwYXRoIGQ9Ik02LjI1IDEwLjEyNUgxMC41VjUuODc1SDYuMjVWMTAuMTI1WiIgZmlsbD0iIzMwRTY3MyIvPgo8cGF0aCBkPSJNMTAuNSAxMC4xMjVIMTQuNzVWNS44NzVIMTAuNVYxMC4xMjVaIiBmaWxsPSIjRkZCRTAwIi8+Cjwvc3ZnPgo="
                alt="Microsoft"
              />
            }
            endIcon={isLoading ? <CircularProgress size="1.2rem" color="inherit" /> : null}
            variant="contained"
            fullWidth
            onClick={handleLogin}
            disabled={isLoading}
            className="microsoftButton"
            size="large"
          >
            {isLoading ? 'Signing In...' : 'Sign in with Microsoft'}
          </Button>
          <SecurityNote>
            <p>🔒 Secure authentication powered by Microsoft Azure</p>
          </SecurityNote>
        </StyledContent>
      </Container>
    </>
  )
}
